<template>
  <div class="ma-4">
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-skeleton-loader class="mx-auto" type="table" />
    </v-sheet>

    <div v-show="!showSkeleton" class="text-h4 mb-2">Grupos de Atendimento</div>
    <v-data-iterator
      v-show="!showSkeleton"
      :no-data-text="noDataText"
      :items="dataGruposRamais"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :no-results-text="noResultsText"
      hide-default-footer
    >
      <template v-slot:header>
        <v-row>
          <v-col cols="7" class="my-2">
            <v-btn
              dark
              color="orangePcm"
              href="/pabx/cadastro/gruposramais/criar"
              target="_blank"
              @click="handleGoToNewGrupoAtendimento"
            >
              Criar Grupo de Atendimento
            </v-btn>
          </v-col>
          <v-col cols="4">
            <v-text-field v-model="search" clearable hide-details prepend-inner-icon="mdi-magnify" label="Busca" />
          </v-col>
        </v-row>
      </template>
      <template v-slot:default="props">
        <v-data-table
          dense
          :headers="headers"
          :items="props.items"
          hide-default-footer
          class="elevation-1"
          disable-pagination
          @dblclick:row="atualizar"
        >
          <template v-slot:[`item.botoes`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  dark
                  color="bluePcm"
                  class="ma-2"
                  :href="`/pabx/cadastro/gruposramais/atualizar/${item._id}`"
                  target="_blank"
                  v-bind="attrs"
                  v-on="on"
                  @click="atualizarButton(item, $event)"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="deletar(item)" icon small dark color="darkRed" v-bind="attrs" v-on="on">
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
              </template>
              <span>Remover</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </template>

      <template v-slot:footer>
        <v-row class="mt-2" align="center" justify="center">
          <div class="ml-4 mb-2 grey--text">
            <p>Total de Grupos de Atendimento: {{ qtdGrupos }}</p>
          </div>
          <v-spacer />
          <div class="pb-5">
            <ListPagination
              :page="page"
              :numberOfPages="numberOfPages"
              @firstPage="firstPage"
              @formerPage="formerPage"
              @nextPage="nextPage"
              @lastPage="lastPage"
            />
          </div>
        </v-row>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import ListPagination from '@/componentes/ListPagination'
import { registerVuexModule } from '@/utils/vuexUtils'
import { pagesHomeMixins } from '@/mixins/pagesHomeMixins'

import gruposRamaisStore from './../_store'
import GruposRamaisHttpService from '../_services/GruposRamaisHttpService'

export default {
  components: { ListPagination },
  mixins: [pagesHomeMixins],
  data: () => ({
    headers: [
      {
        text: 'Grupo',
        value: 'description',
        align: 'left',
      },
      {
        text: 'Estratégia',
        value: 'strategy',
        align: 'left',
        sortable: false,
      },
      {
        text: 'Tempo',
        value: 'time',
        align: 'right',
        sortable: false,
      },
      {
        text: 'Ações',
        value: 'botoes',
        align: 'center',
        sortable: false,
      },
    ],
    dataGruposRamais: [],
    strategyObject: {
      ringall: 'Tocar todos',
      leastrecent: 'Disponível por mais tempo',
      fewestcalls: 'Atendeu menos chamadas',
      random: 'Aleatoriamente',
      rrmemory: 'Sequência definida pelo usuário',
      rrordered: 'Ordenado',
      linear: 'Primeiro ramal livre da sequência',
    },
  }),
  computed: {
    ...mapGetters('grupoRamaisHomeModulePABXStore', ['getGruposRamais']),

    numberOfPages() {
      return Math.ceil(this.dataGruposRamais.length / this.itemsPerPage)
    },
    qtdGrupos() {
      return this.dataGruposRamais.length
    },
  },

  async created() {
    registerVuexModule(this.$store, 'grupoRamaisHomeModulePABXStore', gruposRamaisStore)

    await this.listarGruposRamais()
    this.dataGruposRamais = this.getGruposRamais.map(grupoRamal => ({
      ...grupoRamal,
      strategy: this.strategyObject[`${grupoRamal.strategy}`],
    }))

    this.showSkeleton = false
  },

  methods: {
    ...mapActions('grupoRamaisHomeModulePABXStore', ['listarGruposRamais']),

    handleGoToNewGrupoAtendimento(event) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const handleGoToNewGrupoAtendimento = this.$router.resolve({ name: 'gruposramais/criar' })
        window.open(handleGoToNewGrupoAtendimento.href, '_blank')
      } else {
        this.$router.push({ name: 'gruposramais/criar' })
      }
    },

    atualizar(event, item) {
      if (event.metaKey || event.ctrlKey) {
        const updatePath = this.$router.resolve(`gruposramais/atualizar/${item.item._id}`)
        window.open(updatePath.href, '_blank')
      } else {
        this.$router.push(`gruposramais/atualizar/${item.item._id}`)
      }
    },

    atualizarButton(item, event) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const updatePath = this.$router.resolve(`gruposramais/atualizar/${item._id}`)
        window.open(updatePath.href, '_blank')
      } else {
        this.$router.push(`gruposramais/atualizar/${item._id}`)
      }
    },
    async deletar(item) {
      let resultado = window.confirm(`Deseja remover o grupo de captura "${item.description}"?`)

      if (resultado) {
        try {
          await GruposRamaisHttpService.deleteGruposRamais(item._id)
          this.dataGruposRamais = this.dataGruposRamais.filter(x => x._id !== item._id)
        } catch (error) {
          alert(error.response.data)
        }
      }
    },
  },
}
</script>
